// dependencies
import { useState } from "react";
import { toast } from "react-toastify"

// api
import { sendEmail } from "../../api/email-js/emailJs"

// components
import PrimaryBtn from "../../components/btns/PrimaryBtn";

// icons
import { MdOutlineMailOutline } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { IoShareSocialSharp } from "react-icons/io5";
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaRedditAlien } from "react-icons/fa";

// styles
import styles from "./css/Contact.module.css";



export default function ContactPage() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    })

    const handleSuccessCallback = () => {
        toast("Email Sent Successfully", { type: "success" })

        // clear fields
        setFormData({
            name: "",
            email: "",
            subject: "",
            message: "",
        })
    }
    const handleErrorCallback = (error) => {
        console.error(error)
        alert(`Error sending email: ${error.message}`)
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        // form validation
        const isFormValid = Object.values(formData).every(value => value.trim() !== "")
        if (!isFormValid) {
            alert("Please fill in all fields")
            return
        }

        sendEmail(formData, handleSuccessCallback, handleErrorCallback)
    }

    return (
        // background
        <div className={styles.contactContainer}>
            {/* text, btns, location | img */}
            <div className={styles.contentContainer}>

                {/* text */}
                <div className={styles.textContainer}>
                    <div className={styles.headerText}>
                        Get In <span className={styles.headerName}>Touch</span>
                    </div>
                    <div className={styles.aboutText}>
                        Have a project in mind or want to discuss a potential collaboration? I'd love to hear from you.
                    </div>
                </div>

                {/* form */}
                <div className={styles.formContainer}>
                    <form className={styles.form} onSubmit={handleSubmit}>
                        {/* name | email */}
                        <div className={styles.row}>
                            <div className={styles.fieldGroup}>
                                <label htmlFor="name">Name</label>
                                <input 
                                    type="text" 
                                    id="name" 
                                    name="name" 
                                    placeholder="Your Name" 
                                    required 
                                    value={formData.name} 
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })} 
                                />
                            </div>
                            <div className={styles.fieldGroup}>
                                <label htmlFor="email">Email</label>
                                <input 
                                    type="text" 
                                    id="email" 
                                    name="email" 
                                    placeholder="Your Email" 
                                    required 
                                    value={formData.email} 
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })} 
                                />
                            </div>
                        </div>

                        {/* subject */}
                        <div className={styles.fieldGroup}>
                            <label htmlFor="subject">Subject</label>
                            <input 
                                type="text" 
                                id="subject" 
                                name="subject" 
                                placeholder="Subject of your message" 
                                required 
                                value={formData.subject} 
                                onChange={(e) => setFormData({ ...formData, subject: e.target.value })} 
                            />
                        </div>

                        {/* message */}
                        <div className={styles.fieldGroup}>
                            <label htmlFor="message">Message</label>
                            <textarea 
                                id="message" 
                                name="message" 
                                placeholder="Your Message" 
                                rows="5"
                                required 
                                value={formData.message} 
                                onChange={(e) => setFormData({ ...formData, message: e.target.value })} 
                            />
                        </div>

                        {/* submit */}
                        <div className={styles.btnCOntainer}>
                            <PrimaryBtn text={"Send Message"} />
                        </div>
                    </form>
                </div>

                {/* contact cards */}
                <div className={styles.cardsContainer}>
                    <div className={styles.card}>
                        <MdOutlineMailOutline className={styles.cardIcon} />
                        <div className={styles.cardHeader}>Email</div>
                        <div className={styles.cardText}>luca.haar@icloud.com</div>
                    </div>
                    <div className={styles.card}>
                        <IoLocationOutline className={styles.cardIcon} />
                        <div className={styles.cardHeader}>Location</div>
                        <div className={styles.cardText}>Melbourne, VIC, Australia</div>
                    </div>
                    <div className={styles.card}>
                        <IoShareSocialSharp className={styles.cardIcon} />
                        <div className={styles.cardHeader}>Social</div>
                        <div className={styles.cardIcons}>
                            <a href="https://github.com/CodedBeats" target="_blank" rel="noopener noreferrer">
                                <FaGithub className={styles.social} />
                            </a>
                            <a href="https://www.linkedin.com/in/luca-haar-a2229220a" target="_blank" rel="noopener noreferrer">
                                <FaLinkedin className={styles.social} />
                            </a>
                            <a href="https://www.reddit.com/user/CodedBeatss/" target="_blank" rel="noopener noreferrer">
                                <FaRedditAlien className={styles.social} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
